import React from 'react';
import { injectIntl, FormattedMessage } from 'react-intl';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { Grid, Row, Col, Button } from 'react-bootstrap';

import { formStatusDispatchHelper } from 'actions/FormStatusActions';

import Data from 'components/Data';

import Loader from 'components/layout/Loader';

// show information for the user that he may activate plugins if he has the rights to do so
class DashboardInitSoleRepresentative extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      checked: false,
    };
  }

  render() {
    const {
      intl: { messages },
      myParent,
      formStatus,
    } = this.props;

    return (
      <div class="jumbotron">
        <Data dataName="myParent" url="/api/clients/parent.json" data={myParent} />

        <Grid fluid class="m-b-20 m-t-20">
          <Row>
            <Col lg={6} class="bg-white">
              <div class="padding-30 text-center">Nice video here</div>
            </Col>
            <Col lg={6}>
              <div class="card card-transparent">
                <div class="card-header">
                  <div class="card-title">{messages.getting_started}</div>
                </div>
                <div class="card-block">
                  <h3>{messages.chedri_plugins}</h3>
                  <p>
                    {
                      messages.in_order_to_use_our_software_in_its_full_potential_you_need_to_activate_plugins_in_order_to_do_that_please_confirm_that_you_may_sign_contracts_on_behalf_of_your_company
                    }
                  </p>

                  {myParent.pending ? (
                    <Loader />
                  ) : (
                    <div class="p-t-15">
                      <div class="checkbox check-success no-margin">
                        <input
                          type="checkbox"
                          value="true"
                          name="checked"
                          id="acceptSoleRepresentative"
                          onChange={e => this.setState({ checked: e.target.checked })}
                          checked={this.state.checked}
                        />
                        <label for="acceptSoleRepresentative" style={{ whiteSpace: 'normal' }}>
                          <FormattedMessage
                            id="i_declare_that_i_am_entitled_to_legally_sign_contracts_on_behalf_of_my_company"
                            values={{ company: myParent.data.profile.company }}
                          />
                        </label>
                      </div>

                      <div class="text-right p-t-10">
                        <Button
                          bsStyle="primary"
                          onClick={this.props.onSubmit}
                          disabled={!this.state.checked || formStatus.pending}
                        >
                          <i
                            class={
                              'fa-fw m-r-10 ' +
                              (formStatus.pending ? ' fa fa-circle-notch fa-spin' : 'fal fa-file-contract')
                            }
                          />{' '}
                          {messages.save}
                        </Button>
                      </div>
                    </div>
                  )}
                </div>
              </div>
            </Col>
          </Row>
        </Grid>
      </div>
    );
  }
}

const mapStateToProps = state => {
  return {
    myParent: state.data.myParent,
    formStatus: state.formStatus.initSoleRepresentative,
  };
};
const mapDispatchToProps = dispatch => {
  return {
    onSubmit: () => {
      formStatusDispatchHelper('initSoleRepresentative', '/api/addsolerepresentativerole.json', {}, 'put', dispatch);
    },
  };
};

export default withRouter(
  injectIntl(
    connect(
      mapStateToProps,
      mapDispatchToProps
    )(DashboardInitSoleRepresentative)
  )
);
